import React, { Component } from 'react';
import './HomeOwnerDashboard.scss';
import EmptyImage from './EmptyImage';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '../Icon';

class VideosList extends Component {
  state = {
    isOpen: false,
  };

  render() {
    const { data, playVideo } = this.props;

    return (
      <>
        <div>
          <div className="homeDasboard__mainTile">
            <div style={{ padding: 20 }}>
              <label className="homeDasboard__title">VIDEOS</label>
              {data && data.length > 0 ? (
                <div className="homeDasboard__tile">
                  <div className="homeDasboard__list">
                    {data && data.length > 0
                      ? data.map((item, i) => {
                          let documentData = JSON.parse(item.data);
                          return (
                            <div className="homeDasboard__table">
                              <Link>
                                <div style={{ display: 'flex' }}>
                                  <div style={{ width: '80%' }}>
                                    <label className="homeDasboard__date">
                                      {documentData.name
                                        ? documentData.name
                                        : 'VIDEO' + i}
                                    </label>
                                  </div>
                                  <div
                                    className="homeDasboard__icon"
                                    onClick={() => playVideo(item)}
                                  >
                                    <FontAwesomeIcon
                                      glyph="video"
                                      weight="solid"
                                      size="small"
                                    />
                                  </div>
                                </div>
                              </Link>
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>
              ) : (
                <EmptyImage
                  width={200}
                  height={120}
                  text="You have no Videos."
                  image={'/assets/empty/documents.svg'}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default VideosList;
